module.exports = __webpack_public_path__ + "res/img/note.40890006.png";